import moment from 'moment'

const storedLanguage: string = localStorage.getItem('locale')
moment.locale(storedLanguage)
